import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";
import { auth, registerWithEmailAndPassword, signInWithGoogle } from "../firebase";
import Header from "../components/Header";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  const register = (e, name, email, password) => {
    if (!name) alert("Please enter name");
    registerWithEmailAndPassword(e, name, email, password);
  };

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading, error, navigate]);

  return (
    <>
    {loading === false ? (
    <div className="d-flex align-items-center flex-column mb-0 px-3 splashscreen">
      <Header key="1" user={user}/>
      
      <h2 className="p-2">Sign up</h2>

      <div className="p-2 loginbox">
        <form className="login_form" onSubmit={(e) => register(e, name, email, password)} >
          <input
            type="text"
            className="textbox form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Full Name"
            required
          />
          <input
            type="text"
            className="textbox form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail"
            required
          />
          <input
            type="password"
            className="textbox form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button className="btn btn-primary mb-5 py-2" type="submit">
          Sign up
          </button>
          <button
            className="btn btn-google py-2 mt-3"
            onClick={signInWithGoogle}
          >
          Sign up with Google
          </button>


          
          <div>
            
          </div>
        </form>
      </div>

      <div className="mt-auto pb-5 to_registration text-center">
        <div>Already have an account?<br/><Link to="/">Login</Link></div>
        <div className="footer mt-3">Privacy - Cookie Policy - Contacts</div>
      </div>
    </div>
  ) : (
    <div className="loadingscreen">
      <div className="loading spinner-border text-warning"></div>
    </div>
  ) }
  </>
);
}

export default Register;
